import { useState } from 'react';
import { KeyRound, Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function ChangePasswordFirst() {
  const { currentUser, clearMustChangePassword } = useAuth();
  const navigate = useNavigate();
  const [newPw, setNewPw]         = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [show, setShow]           = useState(false);
  const [error, setError]         = useState('');
  const [saving, setSaving]       = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPw.length < 6) return setError('Password must be at least 6 characters.');
    if (newPw !== confirmPw) return setError('Passwords do not match.');
    setSaving(true);
    try {
      const token = currentUser?.token;
      const res = await fetch('/api/auth/change-password-first', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ newPassword: newPw }),
      });
      const data = await res.json();
      if (!res.ok) return setError(data.message || 'Failed to change password.');
      clearMustChangePassword();
      navigate('/dashboard', { replace: true });
    } catch {
      setError('Cannot connect to server. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const inp = 'w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300 pr-10';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-md">
        <div className="flex items-center justify-center w-14 h-14 rounded-full bg-indigo-100 mx-auto mb-4">
          <KeyRound size={26} className="text-indigo-600" />
        </div>
        <h1 className="text-xl font-bold text-center text-gray-800 mb-1">Set Your Password</h1>
        <p className="text-sm text-center text-gray-500 mb-6">
          Welcome, {currentUser?.name}! Please set a new password before continuing.
        </p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">New Password</label>
            <div className="relative">
              <input
                type={show ? 'text' : 'password'}
                value={newPw}
                onChange={e => setNewPw(e.target.value)}
                className={inp}
                placeholder="Min. 6 characters"
                required
              />
              <button type="button" onClick={() => setShow(s => !s)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                {show ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Confirm Password</label>
            <input
              type={show ? 'text' : 'password'}
              value={confirmPw}
              onChange={e => setConfirmPw(e.target.value)}
              className={inp}
              placeholder="Re-enter new password"
              required
            />
          </div>
          {error && <p className="text-sm text-red-600 bg-red-50 px-3 py-2 rounded-lg">{error}</p>}
          <button
            type="submit"
            disabled={saving}
            className="w-full py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-semibold text-sm disabled:opacity-50">
            {saving ? 'Saving…' : 'Set Password & Continue'}
          </button>
        </form>
      </div>
    </div>
  );
}
